// extracted by mini-css-extract-plugin
module.exports = {"modificationsDishList":"_18GEVWfvKCeWJOjmRK8bIC","externalId":"_2mkMZMhOQQWQs1Z0aQ9ek8"};